import $ from 'jquery'
import { lockBody, unlockBody } from './utils'

$('.js-open-algolia').on('click', function () {
  $('body').addClass('search-active')
  lockBody()
  setTimeout(function () {
    $('.js-algolia-search-input').focus()
  }, 500)
})

$('.js-close-algolia').on('click', function () {
  $('body').removeClass('search-active')
  unlockBody()
})

$('.search-entry').on('click', function (e) {
  if (e.target === this && window.matchMedia('(min-width: 992px)').matches) {
    $('body').removeClass('search-active')
    unlockBody()
  }
})
